<script>
import { get } from "lodash";
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";

export default {
  mixins: [fandomBasicMixin],
  methods: {
    getContentsFromUser(field) {
      const names = get(this, ["user", field], []);
      return names.map(this.getContent);
    }
  },
  computed: {
    theme() {
      const themeName = get(this, ["content", "theme"], "light");
      return `${themeName}-theme bg-${themeName} navbar-${themeName}`;
    },
    user() {
      return get(globalState, ["pageModel", "user"], {});
    },
    industry() {
      return this.getContentsFromUser("industry");
    },
    topic() {
      return this.getContentsFromUser("topic");
    },
    target() {
      return this.getContentsFromUser("target");
    },
    profiler() {
      return get(globalState, ["pageModel", "layout", "content", "profiler_content", "url"], false);
    },
    componentStyle() {
      return {
        "background-color": this.content.background_color
      };
    }
  }
};
</script>

<template>
  <div class="w-100" :class="theme" user-edit-preferences-component :style="componentStyle">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 my-5">
          <p class="h4 font-weight-normal mb-5">{{content.title}}</p>
          <div class="mb-5" v-if="target.length > 0">
            <p>{{ft("user_preferences.target")}}</p>
            <p class="h4" style="font-weight: bold;" v-for="(item, index) in target" :key="`target-${index}`">{{item.title}}</p>
          </div>
          <div class="mb-5" v-if="industry.length > 0">
            <p>{{ft("user_preferences.industry")}}</p>
            <p class="h4" style="font-weight: bold;" v-for="(item, index) in industry" :key="`industry-${index}`">{{item.title}}</p>
          </div>
          <div class="mb-5" v-if="topic.length > 0">
            <p>{{ft("user_preferences.topic")}}</p>
            <div class="topic-grid">
              <div class="py-2 px-3 topic-item bg-white" v-for="(item, index) in topic" :key="`topic-${index}`">
                <div class="text-center small">{{item.title}}</div>
              </div>
            </div>
          </div>
          <a v-if="profiler" :href="profiler" class="btn btn-primary">{{ft("user_preferences.to_profiler")}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.topic-grid {
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(2, 1fr);

  @include media-breakpoint-up(md) {
    grid-template-columns: repeat(3, 1fr);
  }
}

.topic-item {
  border-radius: 3rem;
}
</style>
